/*
 * i18n (emr-web)
 */
import { initI18n } from "@emr/intl"
import enUS from "./locales/en-US.json"
import frCA from "./locales/fr-CA.json"

export const i18n = initI18n({ "en-US": enUS, "fr-CA": frCA })
